import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import getMailboxJunkEmailConfigurationOperation from 'owa-service/lib/operation/getMailboxJunkEmailConfigurationOperation';

export default function getMailboxJunkEmailConfiguration(): Promise<
    MailboxJunkEmailConfigurationOptions
> {
    return getMailboxJunkEmailConfigurationOperation().then(responseMessage => {
        if (responseMessage.WasSuccessful) {
            return responseMessage.Options;
        } else {
            throw new Error(
                `getMailboxJunkEmailConfigurationOperation ${responseMessage.ErrorCode} ${
                    responseMessage.ErrorMessage
                }`
            );
        }
    });
}
